import React, { useState, useEffect } from 'react';
import { Phone, MapPin, Clock, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const Home = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowCookieBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowCookieBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowCookieBanner(false);
  };

  const openWhatsApp = () => {
    const phoneNumber = '351937344555';
    const message = encodeURIComponent('Olá! Gostaria de fazer uma encomenda de açaí.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="logo-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_acai-shop-13/artifacts/soi9vtvh_1000005820.png" 
              alt="Açaí Da Vila Logo" 
              className="brand-logo"
            />
          </div>
          <h1 className="hero-title">Açaí Fresquinho do Brasil</h1>
          <p className="hero-subtitle">Self-Service • 100g por apenas 2,89€</p>
          <Button 
            onClick={openWhatsApp}
            className="cta-button"
            size="lg"
          >
            <Phone className="mr-2 h-5 w-5" />
            Encomendar via WhatsApp
          </Button>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container-custom">
          <div className="about-grid">
            <div className="about-text">
              <h2 className="section-title">Açaí 100% Natural</h2>
              <p className="section-description">
                No Açaí Da Vila, oferecemos açaí puro e fresco do Brasil, além de 
                deliciosas coxinhas, pastéis de feira, esfirras fechadas, caldo de cana 
                e muitas outras iguarias brasileiras. Monte o seu próprio bowl com os 
                toppings que mais gosta e experimente o sabor autêntico do Brasil!
              </p>
              <div className="price-highlight">
                <span className="price-label">Self-Service</span>
                <span className="price-value">2,89€ / 100g</span>
              </div>
            </div>
            <div className="about-images">
              <img 
                src="https://images.unsplash.com/photo-1605217074713-eb3568ac50bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxhJUMzJUE3YSVDMyVBRCUyMGJvd2x8ZW58MHx8fHwxNzc1NDA4MDQ3fDA&ixlib=rb-4.1.0&q=85" 
                alt="Açaí Bowl"
                className="about-image-main"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container-custom">
          <h2 className="section-title-center">Delícias de Açaí</h2>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img 
                src="https://images.pexels.com/photos/36457776/pexels-photo-36457776.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
                alt="Açaí Bowl 1"
              />
            </div>
            <div className="gallery-item">
              <img 
                src="https://images.pexels.com/photos/8465241/pexels-photo-8465241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
                alt="Açaí Bowl 2"
              />
            </div>
            <div className="gallery-item">
              <img 
                src="https://images.unsplash.com/photo-1588068403046-169c80c69938?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMGZydWl0JTIwYm93bHxlbnwwfHx8fDE3NzU0MDgwNTF8MA&ixlib=rb-4.1.0&q=85" 
                alt="Açaí Bowl 3"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Delivery Partners Section */}
      <section className="partners-section">
        <div className="container-custom">
          <h2 className="section-title-center">Encomende Também Através De</h2>
          <div className="partners-grid">
            <Card className="partner-card">
              <img 
                src="https://cdn.worldvectorlogo.com/logos/uber-eats-1.svg" 
                alt="Uber Eats"
                className="partner-logo"
              />
            </Card>
            <Card className="partner-card">
              <img 
                src="https://cdn.worldvectorlogo.com/logos/glovo-1.svg" 
                alt="Glovo"
                className="partner-logo"
              />
            </Card>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contactos">
        <div className="container-custom">
          <h2 className="section-title-center">Contactos</h2>
          
          {/* Google Maps */}
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps?q=A%C3%A7a%C3%AD+Da+Vila,+Av.+Alexandre+Herculano+109,+4480-878+Vila+do+Conde&output=embed"
              width="100%"
              height="450"
              style={{border: 0, borderRadius: '20px'}}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Açaí Da Vila - Av. Alexandre Herculano 109, Vila do Conde"
            ></iframe>
          </div>

          <div className="contact-grid">
            <Card className="contact-card">
              <div className="contact-icon">
                <Phone className="h-8 w-8" />
              </div>
              <h3 className="contact-title">Telefone</h3>
              <p className="contact-info">937 344 555</p>
              <Button 
                onClick={openWhatsApp}
                className="contact-button"
              >
                WhatsApp
              </Button>
            </Card>
            
            <Card className="contact-card">
              <div className="contact-icon">
                <MapPin className="h-8 w-8" />
              </div>
              <h3 className="contact-title">Morada</h3>
              <p className="contact-info">
                Av. Alexandre Herculano 109<br />
                4480-878 Vila do Conde
              </p>
            </Card>
            
            <Card className="contact-card">
              <div className="contact-icon">
                <Clock className="h-8 w-8" />
              </div>
              <h3 className="contact-title">Horário</h3>
              <p className="contact-info">
                Segunda a Sábado: 10:00 - 21:00<br />
                Domingo: 12:00 - 21:00
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container-custom">
          <div className="footer-content">
            <div className="footer-brand">
              <img 
                src="https://customer-assets.emergentagent.com/job_acai-shop-13/artifacts/soi9vtvh_1000005820.png" 
                alt="Açaí Da Vila" 
                className="footer-logo"
              />
              <p className="footer-text">
                Açaí fresquinho do Brasil<br />
                em Vila do Conde
              </p>
            </div>
            <div className="footer-info">
              <h4 className="footer-heading">Contacto</h4>
              <p className="footer-text">937 344 555</p>
              <p className="footer-text">Av. Alexandre Herculano 109</p>
              <p className="footer-text">4480-878 Vila do Conde</p>
            </div>
            <div className="footer-info">
              <h4 className="footer-heading">Encomendas</h4>
              <p className="footer-text">WhatsApp</p>
              <p className="footer-text">Uber Eats</p>
              <p className="footer-text">Glovo</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2024 Açaí Da Vila. Todos os direitos reservados.</p>
            <p className="footer-legal">Política de Privacidade | Proteção de Dados RGPD</p>
          </div>
        </div>
      </footer>

      {/* Cookie Consent Banner */}
      {showCookieBanner && (
        <div className="cookie-banner">
          <div className="cookie-content">
            <div className="cookie-text">
              <h3 className="cookie-title">🍪 Utilizamos Cookies</h3>
              <p className="cookie-description">
                Este website utiliza cookies para melhorar a sua experiência de navegação 
                e garantir o funcionamento adequado do site, em conformidade com o RGPD. 
                Ao continuar a navegar, aceita a utilização de cookies.
              </p>
            </div>
            <div className="cookie-actions">
              <Button 
                onClick={acceptCookies}
                className="cookie-accept"
              >
                Aceitar
              </Button>
              <Button 
                onClick={rejectCookies}
                variant="outline"
                className="cookie-reject"
              >
                Rejeitar
              </Button>
            </div>
          </div>
          <button 
            onClick={rejectCookies}
            className="cookie-close"
            aria-label="Fechar"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;
